export default __webpack_public_path__ + "static/media/upload.c38141cd.svg";